var _rect, _path, _path2, _path3, _path4, _rect2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 9C11.6753 9 10.5 10.1753 10.5 11.625L10.5 24.375C10.5 25.8247 11.6753 27 13.125 27H22.875C24.3247 27 25.5 25.8247 25.5 24.375V11.625C25.5 10.1753 24.3247 9 22.875 9H13.125ZM12 11.625C12 11.0037 12.5037 10.5 13.125 10.5H15V10.875C15 11.2892 15.3358 11.625 15.75 11.625H20.25C20.6642 11.625 21 11.2892 21 10.875V10.5H22.875C23.4963 10.5 24 11.0037 24 11.625V24.375C24 24.9963 23.4963 25.5 22.875 25.5H13.125C12.5037 25.5 12 24.9963 12 24.375V11.625Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 15.5625C13.875 15.0447 14.2947 14.625 14.8125 14.625H21.1875C21.7053 14.625 22.125 15.0447 22.125 15.5625C22.125 16.0803 21.7053 16.5 21.1875 16.5H14.8125C14.2947 16.5 13.875 16.0803 13.875 15.5625Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 18.9375C13.875 18.4197 14.2947 18 14.8125 18H21.1875C21.7053 18 22.125 18.4197 22.125 18.9375C22.125 19.4553 21.7053 19.875 21.1875 19.875H14.8125C14.2947 19.875 13.875 19.4553 13.875 18.9375Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 22.3125C13.875 21.7947 14.2947 21.375 14.8125 21.375H21.1875C21.7053 21.375 22.125 21.7947 22.125 22.3125C22.125 22.8303 21.7053 23.25 21.1875 23.25H14.8125C14.2947 23.25 13.875 22.8303 13.875 22.3125Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 19C22.2386 19 20 21.2386 20 24C20 26.7614 22.2386 29 25 29C27.7614 29 30 26.7614 30 24C30 21.2386 27.7614 19 25 19ZM24.8329 25.7129L27.0418 23.0368C27.1986 22.8468 27.1717 22.5657 26.9817 22.4089V22.4089C26.7917 22.2521 26.5106 22.279 26.3538 22.469L24.4764 24.7435L23.463 23.6035C23.2994 23.4194 23.0175 23.4028 22.8334 23.5664V23.5664C22.6492 23.7301 22.6327 24.012 22.7963 24.1961L24.1556 25.7253C24.2421 25.8226 24.3669 25.8773 24.4971 25.8749C24.6273 25.8725 24.75 25.8134 24.8329 25.7129Z",
    fill: "#109B58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterDone);
export default __webpack_public_path__ + "static/media/registerDone.bb49aba952cdf215cfecba309c082bfa.svg";
export { ForwardRef as ReactComponent };